import React from 'react';
import Icon from '../../../components/AppIcon';

const UsageMetricsCard = ({ quotaUsage, booksCreated, aiGenerations }) => {
  const quotaPercentage = (quotaUsage?.used / quotaUsage?.total) * 100;
  const isQuotaLow = quotaPercentage >= 80;
  const isQuotaCritical = quotaPercentage >= 95;

  const metrics = [
    {
      label: 'Books Created',
      value: booksCreated,
      icon: 'BookOpen',
      color: 'text-primary'
    },
    {
      label: 'AI Generations',
      value: aiGenerations,
      icon: 'Sparkles',
      color: 'text-secondary'
    },
    {
      label: 'Credits Remaining',
      value: quotaUsage?.total - quotaUsage?.used,
      icon: 'Zap',
      color: isQuotaCritical ? 'text-error' : isQuotaLow ? 'text-warning' : 'text-success'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg shadow-sm p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-heading font-semibold text-foreground">Usage Metrics</h3>
        <span className="text-xs text-muted-foreground">Current billing cycle</span>
      </div>
      <div className="space-y-6 mb-6">
        <div>
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-muted-foreground">Credit Usage</span>
            <span className="text-sm font-mono text-foreground">
              {quotaUsage?.used} / {quotaUsage?.total}
            </span>
          </div>
          <div className="relative w-full h-3 bg-muted rounded-full overflow-hidden">
            <div
              className={`absolute top-0 left-0 h-full transition-all duration-400 ease-in-out ${
                isQuotaCritical
                  ? 'bg-error'
                  : isQuotaLow
                  ? 'bg-warning' :'bg-success'
              }`}
              style={{ width: `${Math.min(quotaPercentage, 100)}%` }}
            />
          </div>
          {isQuotaLow && (
            <p className="text-xs text-warning mt-2 flex items-center space-x-1">
              <Icon name="AlertCircle" size={14} />
              <span>
                {isQuotaCritical
                  ? 'Almost out of credits - upgrade to continue' :'Running low on credits'}
              </span>
            </p>
          )}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {metrics?.map((metric, index) => (
            <div key={index} className="p-4 bg-muted/30 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <Icon name={metric?.icon} size={18} className={metric?.color} />
                <span className="text-xs text-muted-foreground">{metric?.label}</span>
              </div>
              <p className="text-2xl font-heading font-bold text-foreground">{metric?.value}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="p-4 bg-primary/5 border border-primary/20 rounded-lg">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={18} className="text-primary flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-foreground mb-1">Usage Tracking</p>
            <p className="text-xs text-muted-foreground">
              Credits reset on the 4th of each month. Unused credits do not roll over to the next billing cycle.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsageMetricsCard;